module.exports = __webpack_public_path__ + "static/media/french.c983b286.svg";